import React from 'react'

import { Box, List, Spinner } from '@factorialco/deprecated-design-system'
import { TasksTaskFragment } from 'generated/resources/graphql'

import { useHasSurveys } from 'modules/employee_onboarding/hooks/useGetTasksProcess'
import type { Task } from 'modules/employee_onboarding/hooks/useTasksFilter'
import { MaterializedItem } from 'modules/processes/domain'

import { SurveyList } from '../Actions/SurveyList'
import TaskItem from '../TasksList/Task'

interface Props {
  items: {
    tasks: Task[]
    actions: MaterializedItem[]
  }
  onToggle: (task: TasksTaskFragment) => Promise<void>
  setActionsCompletedNumber: (value: number) => void
  isFiltering: boolean
  tasksLoading: boolean
}

const ItemsList: React.FC<Props> = ({
  items,
  onToggle,
  setActionsCompletedNumber,
  isFiltering,
  tasksLoading,
}) => {
  const [actionsLoading, setActionsLoading] = React.useState<Record<string, boolean>>({})

  const { enabled: surveysEnabled, loading: surveysLoading } = useHasSurveys()

  const actionsLoaded =
    Object.keys(actionsLoading).length === 0 ||
    Object.values(actionsLoading).every((value) => value === false)

  return (
    <Box position="relative">
      {!tasksLoading && !surveysLoading && (
        <List>
          {surveysEnabled && (
            <SurveyList
              setActionsLoading={setActionsLoading}
              setActionsCompletedNumber={setActionsCompletedNumber}
              isFiltering={isFiltering}
              items={items.actions}
            />
          )}

          {actionsLoaded &&
            items.tasks.map((task) => (
              <TaskItem key={`${task.id}-${task.completedAt}`} task={task} onToggle={onToggle} />
            ))}
        </List>
      )}

      {(tasksLoading || !actionsLoaded) && (
        <Box
          width="full"
          alignItems="center"
          position="absolute"
          height="full"
          background="grey000White"
        >
          <Spinner />
        </Box>
      )}
    </Box>
  )
}

export default ItemsList
